export default __webpack_public_path__ + "static/media/worldMap.c1aeac40.svg";